import { queryClient, trpc } from '@faceup/trpc'

// Pre-check for the "last investigator" guard. Resolves `true` when removing/revoking `memberId` would
// orphan at least one investigation (leave it with no usable investigator), so the caller can open the
// `LastInvestigatorModal` instead of proceeding. Uses the `queryClient` singleton (not `useQueryClient`)
// so it works without a `QueryClientProvider` in scope; the `institutionId` is passed in rather than read
// from `MotherProvider`, so the hook can be called from anywhere (e.g. kredenc's members table, which
// mounts `MotherProvider` only inside its own JSX). The server guard stays the backstop for the
// check-then-act race.
export const useLastInvestigatorGuard = () => {
  const wouldOrphanInvestigations = async (memberId: string, institutionId: string) => {
    const orphanedInvestigations = await queryClient.fetchQuery(
      trpc.investigation.listOrphanedForMember.queryOptions({ memberId, institutionId })
    )
    return orphanedInvestigations.length > 0
  }

  return { wouldOrphanInvestigations }
}
